import Image from "next/image";
import Link from "next/link";

import logo from "../../public/images/logo/wise.png";

import FooterData from "../../data/footer.json";
import SingleFooter from "./FooterProps/SingleFooter";
import CopyRight from "./CopyRight";

const FooterThree = () => {
  return (
    <>
      <footer className="rbt-footer footer-style-1" style={{background:"#1f2735"}}>
        <div className="footer-top">
          <div className="container">
            {FooterData &&
              FooterData.footerOne.map((footer, index) => (
                <div className="row row--15 mt_dec--30" key={index}>
                  <div className="col-lg-5 col-md-6 col-sm-6 col-12 mt--30 mr--30">
                    <div className="footer-widget">
                      <div className="logo">
                        <Link href="/">
                          <Image
                            src={logo}
                            width={202}
                            height={50}
                            priority={true}
                            alt="Edu-cause"
                          />
                        </Link>
                      </div>

                      <p className="description mb_sm-0 mt--20">{footer.description}</p>

                      <ul className="social-icon social-default icon-naked justify-content-start mt_sm_dec--30 mt--20">
                        {footer.socialLink.map((value, innerIndex) => (
                          <li key={innerIndex}>
                            <Link href={value.link}>
                              <i className={value.icon}></i>
                            </Link>
                          </li>
                        ))}
                      </ul>

                      <div className="col-12 mt_sm-0 mt--0">

                          <span className="fw-bold fs-4">contact: {" "} </span>{" "}
                          <Link className="fs-4" style={{fontFamily:"Inter, sans-serif", fontWeight:"600"}} href="#">{" "}{" " + footer.mail + " "}</Link>
                          <Link className="fs-4" style={{fontFamily:"Inter, sans-serif", fontWeight:"600"}} href="#">{"| " + footer.phone}</Link>
                      
                      
                  </div>

                      {/* <div className="contact-btn mt--30">
                        <Link
                          className="rbt-btn hover-icon-reverse btn-border-gradient radius-round"
                          href="#"
                        >
                          <div className="icon-reverse-wrapper">
                            <span className="btn-text">Contact With Us</span>
                            <span className="btn-icon">
                              <i className="feather-arrow-right"></i>
                            </span>
                            <span className="btn-icon">
                              <i className="feather-arrow-right"></i>
                            </span>
                          </div>
                        </Link>
                      </div> */}
                    </div>
                  </div>


                  <div className="col-lg-2 col-md-6 col-sm-6 col-12 mt--30">
                  {/* <SingleFooter
                    classOne="offset-lg-0 col-lg-2 col-md-6 col-sm-6 col-12 mt--30"
                    title="Product Courses"
                    footerType={footer.usefulLinks}
                  /> */}

                  <SingleFooter
                    classOne="col-lg-2 col-md-6 col-sm-6 col-12 mt--30"
                    title="Tech Courses"
                    footerType={footer.techCourses}
                  />
                  </div>

                  <div className="col-lg-1 col-md-6 col-sm-6 col-12 mt--30 ml--60 ml_sm--0">
                 
                  <SingleFooter
                    classOne="col-lg-2 col-md-6 col-sm-6 col-12 mt--30"
                    title="Resources"
                    footerType={footer.ourCompany}
                  />
                  </div>

                  <div className="col-lg-1 col-md-6 col-sm-6 col-12 mt--30 ml--60 ml_sm--0">
                 
                  <SingleFooter
                    classOne="col-lg-2 col-md-6 col-sm-6 col-12 mt--30"
                    title="Codingwise"
                    footerType={footer.codingwise}
                  />
                  </div>

                  
                  


                  



                
                </div>
              ))}
          </div>
        </div>
      </footer>
      <CopyRight />
    </>
  );
};

export default FooterThree;
